<template>
  <div>
    <!--For Tables-->
    <p class="title is-6 has-text-centered">Tables <b-button @click="addTable()" type="is-success" size="is-small" icon-left="plus"></b-button></p>

    <b-collapse
      class="card"
      animation="slide"
      v-for="(table, index) of tables"
      :key="`LAYER_${index}`"
      :open="isOpen == index"
      @open="isOpen = index">
      <template #trigger="props">
        <div class="card-header" role="button">
          <p class="card-header-title">
            {{ `Table ${index + 1}` }}
          </p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
          </a>
        </div>
      </template>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-2">
            <b-button type="is-danger" @click="removeTable(index)">Remove</b-button>
          </div>
          <div class="column is-2">
            <b-field label="Full-Width Table">
              <b-switch v-model="table.is_fullwidth">{{table.is_fullwidth ? 'Yes' : 'No'}}</b-switch>
            </b-field>
            <b-field label="Is Selectable">
              <b-switch v-model="table.is_selectable">{{table.is_selectable ? 'Yes' : 'No'}}</b-switch>
            </b-field>
          </div>
          <div class="column is-3">
            <div class="buttons">
              <b-button type="is-success" @click="addColumn(index)">Add Column</b-button>
              <b-button type="is-success" @click="addRow(index)">Add Row</b-button>
              <div><b>SIZE: </b>{{table.data.length}} X {{table.columns.length}}</div>
            </div>
          </div>
          <div class="column is-3">
            <b-field grouped>
              <b-field label="Generate From" expanded>
                <b-numberinput placeholder="Generate From" :controls="false" v-model="generate_num.from" expanded></b-numberinput>
              </b-field>

              <b-field label="Generate Type" expanded>
                <b-select placeholder="Generate Type" v-model="generate_num.type" expanded>
                  <option value="H">Horizontal</option>
                  <option value="V">Vertical</option>
                </b-select>
                <p class="control">
                  <b-button @click="generateTableNumbersOnCells(index)" type="is-info">Generate</b-button>
                </p>
              </b-field>
            </b-field>
          </div>

          <!--Merged Columns Generator-->
          <div class="column is-12">
            <hr />
            <p class="title is-5 has-text-centered">Merged Column Settings</p>
            <div class="columns is-multiline">
              <div class="column is-12">
                <div class="buttons">
                  <b-button @click="addRowGenerateMGD()" type="is-success">Add Row +</b-button>
                  <b-button type="is-primary" @click="generateMergedTableHeaders(index)">Generate</b-button>
                </div>
              </div>
              <div v-for="(g_row, g_row_i) in merged_cols_no" :key="`GENERATE_ROW_${g_row_i}`" class="column is-12">
                <b-field label="No. of merged columns">
                  <b-numberinput :controls="false" v-model="merged_cols_no[g_row_i]"></b-numberinput>  
                  <p class="control">
                    <b-button @click="removeRowGenerateMGD(g_row_i)" type="is-danger">X</b-button>
                  </p>
                </b-field> 
              </div>
            </div>
            <hr />
          </div>

          <div style="overflow-x: auto;" class="column is-12">
            <table v-if="table.columns.length && table.data.length" class="table is-bordered is-fullwidth">
              <thead>
                <tr>
                  <th v-for="(col, col_i) in table.columns" :key="`TBL_${index}_${col_i}_${col.name}`">
                    <div class="columns">
                      <div class="column"><span>{{col.name}}</span></div>
                      <div class="column">
                        <b-field label="Column Width">
                          <b-numberinput v-model="col.width" size="is-small" :controls="false"></b-numberinput>
                        </b-field>
                      </div>
                      <div class="column">
                        <b-button size="is-small" type="is-danger" @click="removeColumn(index, col_i)">Remove Column</b-button>
                      </div>
                    </div>
                       
                  </th>
                </tr>

                <!--Merged Header Columns-->
                <tr v-for="(merged_header_row, merged_header_row_index) in table.merged_headers" :key="`${index}_MGD_ROW_${merged_header_row_index}`">
                  <th v-for="(merged_header_col, merged_header_col_index) in merged_header_row" :key="`${index}_MGD_ROW_${merged_header_row_index}_COL_${merged_header_col_index}`" :colspan="merged_header_col.cols" :style="`background: ${merged_header_col.data.bg_color};${merged_header_col.data.border_color ? `border : 2px solid ${merged_header_col.data.border_color}` : ''}`">
                    <p class="title is-5 mb-2 has-text-centered">Merged Header Column</p>
                    <set-custom-layout-table-row :key="`CL_MGD_ROW_${merged_header_row_index}_COMPONENT_${merged_header_col_index}`" v-model="merged_header_col.data" :question_type="null"></set-custom-layout-table-row>
                    <b-field label="BG COLOR">
                      <b-input v-model="merged_header_col.data.bg_color"></b-input>
                    </b-field>
                    <b-field label="BORDER COLOR">
                      <b-input v-model="merged_header_col.data.border_color"></b-input>
                    </b-field>
                  </th>
                  <th><b-button type="is-danger" icon-left="close" @click="removeMergedRow(index, merged_header_row_index)"></b-button></th>
                </tr>

              </thead>
              <!--Displays table rows & columns-->
              <tbody>
                <tr v-for="(row, row_i) in table.data" :key="`TABLE_${index}_ROW_${row_i}`">
                  <td v-for="(col, col_i) in table.columns" :key="`TBL_DATA_${index}_${col_i}_${col.name}`" :style="`background: ${table.data[row_i][col_i].bg_color};${(current_cell_meta_data && (index == cellMetaDataToArr[0]) && (row_i == cellMetaDataToArr[1]) && (col_i == cellMetaDataToArr[2])) ? 'border: 2px solid blue;' :  (table.data[row_i][col_i].border_color ? `border: 2px solid ${table.data[row_i][col_i].border_color};` : '')}`" @click="editThisCell(index, row_i, col_i)">
                    <show-custom-layout-object v-model="table.data[row_i][col_i]" :key="`TABLE_${index}_ROW_${row_i}_CLO_${col_i}_COMPONENT`"></show-custom-layout-object>       
                  </td>
                  <td><b-button type="is-danger" icon-left="close" @click="removeRow(index, row_i)"></b-button></td>
                </tr>
              </tbody>
            </table>           
                   
          </div>

          <hr />
          <!--Current Cell-->
          <div class="column is-12">
            <div style="background: #e4e4e4;" v-if="current_cell_object" class="columns is-multiline">
              <div class="column is-12">
                <p class="title is-4 has-text-centered">Currently Selected Cell (Table - {{parseInt(current_cell_meta_data.split('-')[0]) + 1}}, Row - {{parseInt(current_cell_meta_data.split('-')[1]) + 1}}, Column - {{parseInt(current_cell_meta_data.split('-')[2]) + 1}})</p>
              </div>
              <div class="column is-12">
                <set-custom-layout-table-row v-model="tables[cellMetaDataToArr[0]].data[cellMetaDataToArr[1]][cellMetaDataToArr[2]]" :question_type="null"></set-custom-layout-table-row>
                <b-field label="BG COLOR">
                  <b-input v-model="current_cell_object.bg_color"></b-input>
                </b-field>
                <b-field label="BORDER COLOR">
                  <b-input v-model="current_cell_object.border_color"></b-input>
                </b-field>
                <b-field v-if="table.is_selectable" label="Is Selected Answer">
                  <b-checkbox v-model="current_cell_object.is_select_answer"></b-checkbox>
                </b-field>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </b-collapse>
    <!--For CLipart layers end--> 
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import SetCustomLayoutTableRow from '@/components/Question/CustomLayout/SetCustomLayoutTableRow'
import ShowCustomLayoutObject from '@/components/Question/CustomLayout/ShowCustomLayoutObject'
import {returnNewCLOLayer} from '@/components/Question/CustomLayout/utils'

export default {
  name : 'set-tables',
  props : {
    value : {
      type : Array
    }, // Here value = tables (in parent component)
  }, 
  components : {
    SetCustomLayoutTableRow,
    ShowCustomLayoutObject
  },
  data(){
    return {
      isOpen : null,
      tables : this.value,
      current_cell_object : null,
      current_cell_meta_data : null,
      merged_cols_no : [],
      generate_num : {
        from : null,
        to : null,
        type : 'V'
      },
      new_table : {
        merged_headers : [],
        data : [],
        columns : [],
        is_fullwidth : true,
        is_selectable : false
      },
      new_cl_object : { ...returnNewCLOLayer(), 
        bg_color : '#fff', 
        border_color : null, 
        is_select_answer : false 
      }
    }
  },
  computed : {
    ...mapGetters(['fetchCliparts']),
    cellMetaDataToArr(){
      return this.current_cell_meta_data ? this.current_cell_meta_data.split('-') : []
    },
    currentPageCliparts(){
      // Returns all cliparts of this particular page
      return this.fetchCliparts.slice((this.current_clipart_page-1)*this.clipart_page_items, this.current_clipart_page*this.clipart_page_items)
    },
    currentLayerPage(){
      let page = null
      if(this.value[this.isOpen]){
        const clipart = this.value[this.isOpen].clipart
        if(clipart){
          const clipart_id = clipart._id
          const clipart_index = this.fetchCliparts.map(clipart => clipart._id).indexOf(clipart_id)
          page =  Math.floor(clipart_index/this.clipart_page_items) + 1
        }
      }
      return page
    }
  },
  methods : {
    generateTableNumbersOnCells(index){
      if(this.generate_num.type){
        let start = this.generate_num.from ? this.generate_num.from : 1
        if(this.generate_num.type == 'H'){
          for(let row of this.tables[index].data){
            for(let col of row){
              col.type = 'QTEXT'
              col.text = start
              start++
            }
          }  
        }else if(this.generate_num.type == 'V'){
          for(let row_i in this.tables[index].data){
            let row = this.tables[index].data[row_i]
            for(let col_i in row){
              let col = row[col_i]
              col.type = 'QTEXT'
              col.text = start + parseInt(row_i) + (this.tables[index].data.length*col_i)
              
            }
          }  
        }
      }
    },
    addTable(){
      // Add a new clipart layer
      const new_table = JSON.parse(JSON.stringify(this.new_table))
      this.tables.push(new_table)
      // Showing message to user
      this.$buefy.toast.open({
        message: "New Table Added",
        type: "is-success",
      });
    },
    removeTable(index){
      this.tables.splice(index, 1)

      //Showing message to user
      this.$buefy.toast.open({
        message: "Table Removed",
        type: "is-success",
      });
    },
    generateMergedTableHeaders(table_i){
      if(!this.tables[table_i].merged_headers){
        this.tables[table_i].merged_headers = []
      }

      let mrows = []
      for(let cols_merge of this.merged_cols_no){
        let mrow_cols = []
        for(let col_index = 0; col_index < cols_merge; col_index ++){
          let col_span = parseInt(Math.ceil(this.tables[table_i].columns.length/cols_merge))
          mrow_cols.push({
            cols : col_span,
            data : JSON.parse(JSON.stringify(this.new_cl_object))
          })
        }
        mrows.push(mrow_cols)
      }
      this.tables[table_i].merged_headers = mrows
    },
    removeColumn(table_id, col_i){
      //Removing this column from all rows
      this.tables[table_id].data = this.tables[table_id].data.map(row => {
        row.splice(col_i, 1)
        return row
      })
      //Removing from columns
      this.tables[table_id].columns.splice(col_i, 1)
      
      this.tables = JSON.parse(JSON.stringify(this.tables))
    },
    removeRow(table_id, row_i){
      this.tables[table_id].data.splice(row_i, 1)
    },
    removeMergedRow(table_id, row_i){
      this.tables[table_id].merged_headers.splice(row_i, 1)
    },
    addRow(table_id){
      //Creating a new row
      let new_row = []
      for(let col in this.tables[table_id].columns){
        new_row[col] = JSON.parse(JSON.stringify(this.new_cl_object))
      }

      this.tables[table_id].data.push(new_row)
    },
    addColumn(table_id){
      // Adding in columns
      this.tables[table_id].columns.push({ name : `Column ${this.tables[table_id].columns.length + 1}`, width : 100 })

      // Adding in previous data 
      this.tables[table_id].data = this.tables[table_id].data.map(row => {
        row[this.tables[table_id].columns.length - 1] = JSON.parse(JSON.stringify(this.new_cl_object))
        return row
      })
    },
    editThisCell(index, row_i, col_i){
      this.current_cell_meta_data = `${index}-${row_i}-${col_i}`
      this.current_cell_object = this.tables[index].data[row_i][col_i]
    },
    removeRowGenerateMGD(g_row_i){
      this.merged_cols_no.splice(g_row_i, 1)
    },
    addRowGenerateMGD(){
      this.merged_cols_no.push(1)
    },
    emitData(){
      this.$emit('input', this.value)
    }
  },
  watch : {
    value : function(new_val){
      this.tables = new_val
    },
    tables : {
      handler(){
        this.emitData()
      },
      deep : true
    }
  },
  created(){
    this.tables = this.value
  }
}
</script>
